'use client';
import { useState } from 'react';
import { Provider } from 'react-redux';

import { AppStore, makeStore, PreloadedAppState } from '../lib/store';

export default function StoreProvider({
  children,
  preloadedState,
}: {
  children: React.ReactNode;
  preloadedState?: PreloadedAppState;
}) {
  const [store] = useState<AppStore>(() => makeStore(preloadedState));

  return <Provider store={store}>{children}</Provider>;
}
